module.exports = __webpack_public_path__ + "static/media/auth.c0ceb8d8.webp";